export default "__VITE_ASSET__CLoFXOrs__"